import { useState } from 'react';
import { templates } from './data/templates';
import { ChartHeader } from './components/ChartHeader';
import { SummaryTab } from './components/SummaryTab';
import { TimelineTab } from './components/TimelineTab';
import { EncounterTab } from './components/ChartTabs';
import { HistoryTab } from './components/HistoryTab';

export type TabId = 'summary' | 'timeline' | 'history' | 'encounter';

export default function App() {
  const [activeTab, setActiveTab] = useState<TabId>('summary');
  const [signed, setSigned] = useState(false);

  const activeTemplate = templates[0];

  const tabs: { id: TabId; label: string }[] = [
    { id: 'summary', label: 'Patient' },
    { id: 'timeline', label: 'Documents' },
    { id: 'history', label: 'History' },
    { id: 'encounter', label: 'Visit' },
  ];

  return (
    <div className="app" data-claryn-template={activeTemplate.id} data-claryn-signed={signed ? 'true' : undefined}>
      <div className="topbar">
        <div className="topbar-brand">
          <span className="topbar-logo">DemoEHR</span>
          <span className="topbar-badge">DEMO</span>
        </div>
        <div className="topbar-nav">
          <span className="topbar-nav-item">Schedule</span>
          <span className="topbar-nav-item active">Charts</span>
          <span className="topbar-nav-item">Messages</span>
          <span className="topbar-nav-item">Reports</span>
        </div>
        <div className="topbar-right">
          {!signed ? (
            <button className="sign-off-btn" onClick={() => setSigned(true)}>
              Sign &amp; Close
            </button>
          ) : (
            <span className="signed-badge">Signed</span>
          )}
          <span className="topbar-user">Dr. Smith</span>
        </div>
      </div>

      {signed && (
        <div className="signed-banner">
          This visit has been signed and locked.
        </div>
      )}

      <div className="main-layout">
        <div className="chart-area">
          <ChartHeader template={activeTemplate} />

          <div className="chart-tabs-container">
            <nav className="tab-bar">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`tab-btn${activeTab === tab.id ? ' active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </nav>

            <div className="tab-content">
              {activeTab === 'summary' && <SummaryTab template={activeTemplate} />}
              {activeTab === 'timeline' && <TimelineTab template={activeTemplate} />}
              {activeTab === 'history' && <HistoryTab template={activeTemplate} />}
              {activeTab === 'encounter' && <EncounterTab template={activeTemplate} signed={signed} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
